module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTGEO-55Roman_0.fab9c37e.otf";